import dayjs from 'dayjs';
import { Tooltip } from '@mui/material';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';
import { useTranslation } from 'react-i18next';

type AvailabilityMap = Map<string, { start: string; end: string }[]>;

export const useCreateServerDay = (availabilityMap: AvailabilityMap) => {
    const { t } = useTranslation();

    const ServerDay = function ServerDay(props: PickersDayProps) {
        const { day, disabled, outsideCurrentMonth } = props;

        const currentDay = day as dayjs.Dayjs;

        if (disabled || outsideCurrentMonth) {
            return (
                <PickersDay {...props} />
            );
        }

        const dateKey = currentDay.format('YYYY-MM-DD');
        const availableSlots = availabilityMap.get(dateKey);

        const renderTooltipContent = () => {
            if (!availableSlots || availableSlots.length === 0) return null;

            return (
                <div style={{ textAlign: 'center' }}>
                    <strong>{t('landing.createServerDay.availableSlots')}</strong>
                    {availableSlots.map((slot, index) => (
                        <div key={index}>
                            {dayjs(slot.start, 'HH:mm').format('h:mm A')} - {dayjs(slot.end, 'HH:mm').format('h:mm A')}
                        </div>
                    ))}
                </div>
            );
        };

        if (availableSlots && availableSlots.length > 0) {
            return (
                <Tooltip title={renderTooltipContent()} arrow placement="top">
                    <PickersDay {...props} className={`${props.className} available-day`} />
                </Tooltip>
            );
        }

        return (
            <PickersDay {...props} />
        );
    };

    return ServerDay;
};